import { render, staticRenderFns } from "./viewEmployee.vue?vue&type=template&id=613437e4&scoped=true&"
import script from "./viewEmployee.vue?vue&type=script&lang=js&"
export * from "./viewEmployee.vue?vue&type=script&lang=js&"
import style0 from "./viewEmployee.vue?vue&type=style&index=0&id=613437e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613437e4",
  null
  
)

export default component.exports